import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

/** One item in an in-app inbox (an InApp NotificationDelivery). Mirrors the API's InboxItemDto. */
export interface InboxItem {
  id: string;
  notificationId: string;
  type: number;
  title: string;
  body: string;
  read: boolean;
  readAt: string | null;
  createdAt: string;
  dataJson: string | null;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

/**
 * Reads/marks an in-app inbox, parameterized by the endpoint base so the same service serves any
 * orderYaa surface — partner (company-user) `…/api/notifications/staff/inbox`, rider
 * `…/api/rider/notifications/inbox`. The surface's own auth interceptor attaches the right JWT.
 */
@Injectable({ providedIn: 'root' })
export class InboxService {
  private readonly http = inject(HttpClient);

  getInbox(base: string, take = 20): Observable<ApiResponse<InboxItem[]>> {
    return this.http.get<ApiResponse<InboxItem[]>>(`${base}?take=${take}`);
  }

  getUnreadCount(base: string): Observable<ApiResponse<number>> {
    return this.http.get<ApiResponse<number>>(`${base}/unread-count`);
  }

  markRead(base: string, deliveryId: string): Observable<ApiResponse<unknown>> {
    return this.http.post<ApiResponse<unknown>>(`${base}/${deliveryId}/read`, {});
  }
}
